import { HttpErrorResponse } from '@angular/common/http';
import { Component, HostListener, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SubmitgyanService } from 'src/app/core/services/submit-gyan/submitgyan.service';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonServiceService } from './../../core/services/common-service/common-service.service';

interface Topic {
    name: string;
    id: number;
    isOrganisationalLabel: boolean;
    isArticleCountToZero: boolean;
    keyConcept: Array<KeyConcept>;
    subtopics: Array<Topic>;
    sources: Array<any>;
    sourceParams: SourceParams;
    sourcesSubTopic: SourcesSubTopic;
    exportDocumentRules: any;
    parentSearchContextList: Array<number>;
    parentRelContextList: Array<number>;
    globalRelevance: boolean;
    processNonArticles: boolean;
    suppressSummary: boolean;
    suppressMDS?: boolean;
    ignoreProcess?: boolean;
    dor?: any;
    intentScore?: any;
    level: number;
    showAddIcon: boolean;
    ParentList: Array<number>;
    ParentValueChanged: boolean;
    isTemplate: boolean;
}

interface KeyConcept {
    name: string;
    isSearch: boolean;
    isRelevance: boolean;
}

interface SourceParams {
    [key: string]: any;
}

interface SourcesSubTopic {
    repoIds: { [key: string]: any };
    repoAvailable: boolean;
    knowledgeStoreIds: { [key: string]: any };
    includeSubTopic: { [key: string]: boolean };
    webAvailable: boolean;
    favouriteWebsites: Array<string>;
    dispreferredWebsites: Array<string>;
}
@Component({
    selector: 'app-gyan-templates',
    templateUrl: './gyan-templates.component.html',
    styleUrls: ['./gyan-templates.component.scss'],
})
export class GyanTemplatesComponent implements OnInit {
    faAngleUp = faAngleUp;
    faAngleDown = faAngleDown;
    topics: any;
    selectedOntology: any;
    popupVisible = false;
    isMobile = false;

    @Input() topic!: Topic;
    @Input() modal!: NgbActiveModal;
    @Output() subtopicsUpdated = new EventEmitter<any>(); //EventEmitter<Array<Topic>>();
    // @Output() subtopicMainAttributes = new EventEmitter<any>();

    constructor(
        private submitgyanService: SubmitgyanService,
        private commonServiceService: CommonServiceService,
    ) {}

    ngOnInit(): void {
        this.getTemplatesAndRecentLibraries();
        this.checkWidth();
    }

    getTemplatesAndRecentLibraries() {
        this.submitgyanService.getTemplatesAndRecentLibrary().subscribe({
            next: (response: any) => {
                const data = response;
                this.topics = data;
                console.log('the recentLibraries', data);
                console.log('the recentLibraries', data[0].ontologies[1]);
            },
            error: (error: HttpErrorResponse) => {},
            complete: () => {},
        });
    }

    togglePopup(event: MouseEvent, ontology: any) {
        event.stopPropagation(); // Prevent triggering outside click event when clicking the icon
        if (this.selectedOntology === ontology && this.popupVisible) {
            this.hidePopup(); // Close if clicked again on the same icon
        } else {
            this.selectedOntology = ontology;
            this.popupVisible = true;
        }
    }

    hidePopup() {
        this.popupVisible = false;
        this.selectedOntology = null;
    }

    @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event) {
        if (this.popupVisible) {
            this.hidePopup(); // Close the popup if an outside click is detected
        }
    }

    ontologyTooltip(ontology: any) {
        return ontology.childOntologys && ontology.childOntologys.length ? 'Has child ontologies' : 'No child ontologies';
    }

    // Function to apply the template and update current topic with parent ontology attributes
    applyTemplate(ontology: any): void {
        this.modal.dismiss('Cross click'); // close popup
        // copying parent-level ontology attributes to the current topic
        this.updateTopicFromOntology(ontology);
        console.log('ontology', ontology);
        console.log('current topic with parent ontology:', this.topic);

        // convert and add child ontologies as subtopics after parent data is saved
        const newSubtopics: Array<Topic> = this.convertOntologySubtopicsToTopics(ontology.childOntologys || []);
        console.log('newSubtopics', newSubtopics);
        //debugger;
        //const newSubtopicsAfterAddingParent = this.replaceIdInParentSearchContext(newSubtopics, ontologyId, this.topic.id);

        // emit an event to notify that subtopics have been updated
        this.topic.subtopics = newSubtopics;
        this.subtopicsUpdated.emit(this.topic);
        this.commonServiceService.callValidationForSubmitGyanFromSubtopic(true);
        //this.subtopicMainAttributes.emit(this.topic)
    }

    // updating current topic with all attributes from ontology except the name and id
    /* eslint-disable sonarjs/cognitive-complexity */
    updateTopicFromOntology(ontology: any): void {
        this.topic.isOrganisationalLabel = ontology.isOrganisationalLabel || false;
        this.topic.isArticleCountToZero = ontology.isArticleCountToZero || false;
        this.topic.keyConcept =
            ontology.keyWords?.map((kw: any) => ({
                name: kw.keywords,
                isSearch: kw.isForSearch || false,
                isRelevance: kw.isForRelevance || false,
            })) || [];
        this.topic.sources = ontology.sources || [];
        this.topic.sourceParams = ontology.sourceParams || {};
        this.topic.sourcesSubTopic = {
            repoIds: ontology.sourcesSubTopic?.repoIds || {},
            repoAvailable: ontology.sourcesSubTopic?.repoAvailable || true,
            knowledgeStoreIds: ontology.sourcesSubTopic?.knowledgeStoreIds || {},
            includeSubTopic: ontology.sourcesSubTopic?.includeSubTopic || {},
            webAvailable: ontology.sourcesSubTopic?.webAvailable || false,
            favouriteWebsites: ontology.sourcesSubTopic?.favouriteWebsites || [],
            dispreferredWebsites: ontology.sourcesSubTopic?.dispreferredWebsites || [],
        };
        this.topic.exportDocumentRules = ontology.exportDocumentRules || null;
        if (ontology.isOrganisationalLabel || ontology.isArticleCountToZero) {
            this.topic.parentSearchContextList = [];
            this.topic.parentRelContextList = [];
        }
        //this.topic.parentSearchContextList = ontology.parentSearchContextList || [];
        //this.topic.parentRelContextList = ontology.parentRelContextList || [];
        this.topic.globalRelevance = ontology.globalRelevance || false;
        this.topic.processNonArticles = ontology.processNonArticles || false;
        this.topic.suppressSummary = ontology.suppressSummary || false;
        this.topic.suppressMDS = ontology.suppressMDS || false;
        this.topic.ignoreProcess = ontology.ignoreProcess || false;
        this.topic.dor = ontology.dor || null;
        this.topic.intentScore = ontology.intentScore || null;
        this.topic.level = this.topic.level;
        this.topic.showAddIcon = false;
        this.topic.ParentList = ontology.ParentList || [];
        this.topic.ParentValueChanged = ontology.ParentValueChanged || false;
        this.topic.isTemplate = true;
    }

    // Recursive function to find the correct subtopic and merge new subtopics
    addSubtopicsToCorrectLevel(currentTopic: Topic, newSubtopics: Array<Topic>, targetTopicId: number): void {
        // If the current topic matches the targetTopicId, add the new subtopics here
        if (currentTopic.id === targetTopicId) {
            currentTopic.subtopics = [...newSubtopics, ...currentTopic.subtopics]; // Merge new subtopics
            return; // Stop recursion once the target topic is found and updated
        }

        // Otherwise, check each subtopic recursively to find where to add the new subtopics
        for (const subtopic of currentTopic.subtopics) {
            this.addSubtopicsToCorrectLevel(subtopic, newSubtopics, targetTopicId);
        }
    }

    // converting only subtopics from ontology to Topic interface
    /* eslint-disable sonarjs/cognitive-complexity */
    convertOntologySubtopicsToTopics(childOntologys: Array<any>): Array<Topic> {
        return childOntologys
            .map((ontology) => ({
                name: ontology.name,
                id: ontology.id,
                isOrganisationalLabel: ontology.isOrganisationalLabel || false,
                isArticleCountToZero: ontology.isArticleCountToZero || false,
                keyConcept:
                    ontology.keyWords?.map((kw: any) => ({
                        name: kw.keywords,
                        isSearch: kw.isForSearch || false,
                        isRelevance: kw.isForRelevance || false,
                    })) || [],
                subtopics: this.convertOntologySubtopicsToTopics(ontology.childOntologys || []), // recursively convert child ontologies
                sources: ontology.sources || [],
                sourceParams: ontology.sourceParams || {},
                sourcesSubTopic: {
                    repoIds: ontology.sourcesSubTopic?.repoIds || {},
                    repoAvailable: ontology.sourcesSubTopic?.repoAvailable || true,
                    knowledgeStoreIds: ontology.sourcesSubTopic?.knowledgeStoreIds || {},
                    includeSubTopic: ontology.sourcesSubTopic?.includeSubTopic || {},
                    webAvailable: ontology.sourcesSubTopic?.webAvailable || false,
                    favouriteWebsites: ontology.sourcesSubTopic?.favouriteWebsites || [],
                    dispreferredWebsites: ontology.sourcesSubTopic?.dispreferredWebsites || [],
                },
                exportDocumentRules: ontology.exportDocumentRules || null,
                parentSearchContextList: ontology.parentSearchContextList,
                parentRelContextList: ontology.parentRelContextList,
                globalRelevance: ontology.globalRelevance || false,
                processNonArticles: ontology.processNonArticles || false,
                suppressSummary: ontology.suppressSummary || false,
                suppressMDS: ontology.suppressMDS || false,
                ignoreProcess: ontology.ignoreProcess || false,
                dor: ontology.dor || null,
                intentScore: ontology.intentScore || null,
                level: this.topic.level + 1, // increase level relative to the parent topic
                showAddIcon: false,
                viewIndex: ontology.viewIndex || null,
                ParentList: ontology?.ParentList || [],
                ParentValueChanged: ontology?.ParentValueChanged || false,
                isTemplate: true,
            }))
            .sort((a, b) => {
                // sorting by viewIndex, handling null or undefined values
                const viewIndexA = a.viewIndex ?? Infinity; // treating null/undefined as the largest value
                const viewIndexB = b.viewIndex ?? Infinity;
                return viewIndexA - viewIndexB; // this is for ascending order
            });
    }

    checkWidth() {
        const width = window.innerWidth;
        if (width < 768) this.isMobile = true;
        else this.isMobile = false;
    }
}
